import { useQuery } from '@pinia/colada';
import { ref, Ref } from 'vue';

import { PortfolioStatisticsFilter } from '../enums/portfolio-statistics-filter.enum';
import portfolioStatisticsService from '../services/portfolio-statistics.service';

export function getPortfolioHotUnitsQueryKey(filter: PortfolioStatisticsFilter) {
  return ['portfolio-hot-units', filter];
}

export function usePortfolioHotUnitsQuery(filter: Ref<PortfolioStatisticsFilter>) {
  return useQuery({
    key: () => getPortfolioHotUnitsQueryKey(filter.value),
    query: () => portfolioStatisticsService.getHotUnits(filter.value),
  });
}
